import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ActionTabsWrap = styled.div`
  display: flex;
  padding: 0 ${theme.spacing['2xm']};
  border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
  margin-bottom: ${theme.spacing['2xm']};

  overflow-x: auto;
  ::-webkit-scrollbar-thumb {
    border: 6px solid ${theme.colors.neutral.white};
  }
`

export const ActionTabsItem = styled.button`
  padding: ${theme.spacing.xs};
  color: ${theme.colors.neutral.light};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  background-color: transparent;
  border: 0;
  font-size: ${theme.typography.sizes.xs};
  padding: ${theme.spacing.md};
  border-bottom: ${theme.shapes.borderWidth.md} transparent;
  white-space: nowrap;
  transition: all 0.5s;

  :disabled {
    pointer-events: none;
    color: ${theme.colors.neutral.lighthover};
  }

  &:hover {
    background-color: ${theme.colors.neutral.clear};
  }

  &.active {
    border-bottom-color: ${theme.colors.primary.main};
    color: ${theme.colors.primary.main};
  }
`
